import { DcTenantCode } from './tenant';

export type CurrencyCode = 'AUD' | 'NZD' | 'USD';

export type CurrencyCodeLower = Lowercase<CurrencyCode>;

export function mapTenantToCurrencyCode(tenant: DcTenantCode): CurrencyCode {
  switch (tenant) {
    case 'au':
      return 'AUD';
    case 'nz':
      return 'NZD';
    case 'us':
    case 'global':
      return 'USD';
    default: {
      const _exhaustiveCheck: never = tenant;
      throw new Error(`Unhandled tenant code: ${_exhaustiveCheck}`);
    }
  }
}

export function mapTenantToLowerCurrencyCode(tenant: DcTenantCode): CurrencyCodeLower {
  // SAFETY(legacy): unreviewed, pre-dates this rule.
  return mapTenantToCurrencyCode(tenant).toLowerCase() as CurrencyCodeLower;
}
